var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkbox-component p-2", attrs: { row: "", wrap: "" } },
    _vm._l(_vm.list, function (item, index) {
      return _c(
        "v-flex",
        { key: index, style: _vm.getStyle(item), attrs: { xs12: "" } },
        [
          item.name != "point"
            ? _c(
                "v-checkbox",
                {
                  staticClass: "p-2 mt-0",
                  attrs: {
                    color: "success",
                    value: item.body,
                    "hide-details": "",
                    readonly: _vm.readonly,
                  },
                  on: { change: _vm.onCheckboxChange },
                  model: {
                    value: _vm.checkbox,
                    callback: function ($$v) {
                      _vm.checkbox = $$v
                    },
                    expression: "checkbox",
                  },
                },
                [
                  _c("template", { slot: "label" }, [
                    _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.parserBody(item)) },
                    }),
                  ]),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }